import { AlaFormulario } from './AlaFormulario';
import { NivelFormulario } from './NivelFormulario';
import { Compass } from './compass';
import { Contenido } from './Contenido';
import { ContenidoPlano } from '../../../node_modules/interiores-mapa/dist';
import { Constantes } from './constantes';

export class Vertical {

    Nombre: string;
    Plantas: Planta[];
    NumeroContenidos = 0; // Suma del numero de contenidos de las plantas de la vertical

	constructor() {
        this.Nombre = '';
        this.Plantas = [];
    }

    fromALA(ENTIDAD: any){
        
        if (ENTIDAD) {
            const aux = new Planta().fromALA(ENTIDAD);
            this.Plantas.push(aux);
            this.Nombre = ENTIDAD.Nomobre;
        }
        else{
      
        }

        return this;

    }

    fromESPACIO(ENTIDAD: any){
        console.log(ENTIDAD)
        if (ENTIDAD) {
            this.Nombre = ENTIDAD.ESPACIO.Nombre;
        }

        return this;

    }
    
}


export class Planta {

    Nombre: String;
    Ala: AlaFormulario;
    Nivel: NivelFormulario;
    Contenidos: Contenido[] = [];

	zoomLevels: any[];
	currentZoomLevel: number;
	pathSvgPlano: any;
	pathPlano: any;
	compass: any;

	constructor() {
        this.Contenidos = [];
    }

    fromALA(ENTIDAD: any){
        if (ENTIDAD) {
            const aux = new AlaFormulario(ENTIDAD);
            this.Ala = aux;
            this.pathPlano = this.Ala.RutaImagen;
            this.Nombre = this.Ala.Nomobre;
            this.Nivel = new NivelFormulario(ENTIDAD.NIVEL);
        }
        else{
      
        }

        return this;
    }

    
}


export class VerticalManager {
    
	constructor() {
        return this;
    }

    public generarVerticalesFromNIVELES(niveles): Vertical[]{
        const verticales: Vertical[] = [];
        if (niveles) {
            console.log(niveles)
            niveles.forEach(nivel => {
                if (nivel.ALAS) {

                    nivel.ALAS.forEach(ala => {
                        
                        let vertical = verticales.find( v => v.Nombre === ala.Nomobre);
                        const planta = new Planta().fromALA(ala);

                        if (vertical) {
                            vertical.Plantas.push(planta);
                            
                            const index = verticales.indexOf(vertical);
                            verticales[index] = vertical;
                        }
                        else {
                            vertical = new Vertical().fromALA(ala);
                            verticales.push(vertical);
                        }

                    }); 
                }

            });
        }

        return verticales;
    }

    public generarVerticalesFromESPACIO(niveles): Vertical[]{
        const verticales: Vertical[] = [];
        if (niveles) {
        
            niveles.forEach(nivel => {
                if (nivel.ALAS) {

                    nivel.ALAS.forEach(ala => {

                        let vertical = verticales.find( v => v.Nombre === nivel.ESPACIO.Nombre);
                        

                        const planta = new Planta().fromALA(ala);

                        if (vertical) {
                            vertical.Plantas.push(planta);
                            const index = verticales.indexOf(vertical);
                            verticales[index] = vertical;
                        }
                        else {
                            vertical = new Vertical().fromESPACIO(nivel);
                            vertical.Plantas.push(planta);
                            verticales.push(vertical);
                        }

                    });
                    
                }
                
            });
        }

        return verticales;
    }
    
    // Asignar contenidos a Plantas y refrescar vertical.NumeroContenidos
    public asignarContenidosAVerticales(verticales: Vertical[], contenidos: Contenido[], ordenNoVertical){
        const verticalesAux = verticales;
        verticales.forEach(vertical => {
            vertical.NumeroContenidos = 0;
            vertical.Plantas.forEach(planta => {
                const contenidosPlanta = contenidos.filter( c => c.ALA_PLANO.Id === planta.Ala.Id);
                planta.Contenidos = contenidosPlanta;
                vertical.NumeroContenidos += contenidosPlanta.length;
            });
            if(ordenNoVertical){
                vertical.Plantas.sort( (p1, p2) => p2.Nivel.NivelVertical - p1.Nivel.NivelVertical);
            }else{
                vertical.Plantas.sort( (p1, p2) => p1.Nivel.NivelVertical - p2.Nivel.NivelVertical);
            }   
            
        });
        return verticalesAux;
    }

    public getContenidosPlano(planta: Planta): ContenidoPlano[]{
        const contenidosPlano: ContenidoPlano[] = [];

        planta.Contenidos.forEach(element => {
            const contP = this.setContenidoPlano(element);
            contenidosPlano.push(contP);
        });

        return contenidosPlano;

    }

    private setContenidoPlano(contenido): ContenidoPlano{
		try {
			let contenidoPlano;
			if (contenido.TIPOLOGIA_CONTENIDO) {
				contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, contenido.TIPOLOGIA_CONTENIDO.IconoRepresentacion, [], contenido.ALA_PLANO.IconoContenidoScale);
			}
			else{
				const icono = 'assets/planos/iconos/' + 'wifi.png';
				contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, icono, [], contenido.ALA_PLANO.IconoContenidoScale);
				console.log('5.- NO TIPOLOGIA NODO');
			}
			contenidoPlano.ENTIDAD = contenido.ENTIDAD;

            contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
            contenidoPlano.symbolFill = Constantes.contenidoSymbolFill;
            contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
            contenidoPlano.symbolSize = Constantes.contenidoSymbolSize;
            contenidoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
            contenidoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
            contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
            contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
            contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
            contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);
            contenidoPlano.setIconAlign(contenido.TIPOLOGIA_CONTENIDO.AnchorPoint);
            
            const alineacion = contenido.TIPOLOGIA_CONTENIDO.AnchorPoint;
            const width =  parseInt(Constantes.contenidoIconWidth, 0);
            if (alineacion === 'top-left') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + width);
                contenidoPlano.setLabelYoffset(30);
            }
            else if (alineacion === 'top-center') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + (width / 2));
                contenidoPlano.setLabelYoffset(30);
            }
            else if (alineacion === 'top-right') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10);
                contenidoPlano.setLabelYoffset(30);
            }
            else if (alineacion === 'center-left') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + width);
                contenidoPlano.setLabelYoffset(-15);
            }
            else if (alineacion === 'center-center') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + (width / 2));
                contenidoPlano.setLabelYoffset(-15);
            }
            else if (alineacion === 'center-right') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10);
                contenidoPlano.setLabelYoffset(-15);
            }
            else if (alineacion === 'bottom-left') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + width);
                contenidoPlano.setLabelYoffset(-30);
            }
            else if (alineacion === 'bottom-center') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10 + (width / 2));
                contenidoPlano.setLabelYoffset(-30);
            }
            else if (alineacion === 'bottom-right') {
                contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
                contenidoPlano.setLabelXoffset(10);
                contenidoPlano.setLabelYoffset(-30);
            }
    
            contenidoPlano.setLabel(contenido.Titulo);
            contenidoPlano.setLabelColor(Constantes.labelColor);
            contenidoPlano.setLabelFontFamily(Constantes.labelFontFamily);
            contenidoPlano.setLabelFontSize(Constantes.labelFontSize);

			return contenidoPlano;
		}
		catch (ex) {
			console.log(ex);
		}
	}

}






// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Vertical.ts